import { render, staticRenderFns } from "./RoleSelectModal.vue?vue&type=template&id=8b3fd3b4&scoped=true&"
import script from "./RoleSelectModal.vue?vue&type=script&lang=js&"
export * from "./RoleSelectModal.vue?vue&type=script&lang=js&"
import style0 from "./RoleSelectModal.vue?vue&type=style&index=0&id=8b3fd3b4&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b3fd3b4",
  null
  
)

export default component.exports